import { EventEmitter } from 'events'

export const recorderEventBus = new EventEmitter()